import React from 'react'
import Delete from '@mui/icons-material/Delete'
import Paper from '@mui/material/Paper'
import Table from '@mui/material/Table'
import TableHead from '@mui/material/TableHead'
import TableBody from '@mui/material/TableBody'
import TableRow from '@mui/material/TableRow'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import IconButton from '@mui/material/IconButton'
import { FieldArray } from 'react-final-form-arrays'
import { useTranslation } from 'react-i18next'
import { prop } from 'ramda'
import { styled } from '@mui/material'
import Box from '@mui/material/Box'

import ConstrainedField from '~/components/Fields/ConstrainedField'

const RootStyled = styled(Box)({
  height: '100%',
  overflow: 'auto',
  marginTop: 20,
  minHeight: 100
})

const TableStyled = styled(Table)({
  width: '100%',
  '& th': {
    textAlign: 'left'
  }
})

function BarcodeList () {
  const { t } = useTranslation()

  return (
    <RootStyled>
      <TableContainer component={Paper}>
        <TableStyled>
          <TableHead>
            <TableRow>
              <TableCell>{t('Unit number')}</TableCell>
              <TableCell>{t('Serial number')}</TableCell>
              <TableCell>{t('Quantity')}</TableCell>
              <TableCell colSpan={2}>{t('Condition code')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <FieldArray name="lineItems">
              {({ fields }) => {
                const value = fields.value

                return fields.map((name, index) => {
                  const item = value[index]
                  const unitNumber = prop('unitNumber', item)
                  const totalQuantity = prop('totalQuantity', item)

                  return (
                    <TableRow key={index}>
                      <TableCell>{unitNumber}</TableCell>
                      <TableCell>{value[index].serialNumber}</TableCell>
                      <TableCell sx={{ width: '100px' }}>
                        <ConstrainedField
                          name={`${name}.quantity`}
                          data-cy={`${name}.quantity`}
                          maxValue={totalQuantity}
                          allowEmpty={true}
                          minValue={1}
                        />
                      </TableCell>
                      <TableCell>{value[index].conditionCode}</TableCell>
                      <TableCell align="right">
                        <IconButton onClick={() => fields.remove(index)} size="large">
                          <Delete />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  )
                })
              }}
            </FieldArray>
          </TableBody>
        </TableStyled>
      </TableContainer>
    </RootStyled>
  )
}

export default BarcodeList
